import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown, Table, Loader} from 'semantic-ui-react';
import {pageSizes} from '../../common/constants/lists';
import {getNumericValue} from '../../common/util/fieldsValidation';
import {Actions} from '../../common/actions';
import TablePaginator from '../../common/components/tablePaginator';

class TableRecords extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onPageClick = this.onPageClick.bind(this);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
  }

  componentDidMount() {
    this.props.changeMonthReportPageSize(20);
    this.props.changeMonthReportPage(0);
  }

  renderReport() {
    const {setReportList} = this.props;
    if (!setReportList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return setReportList.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.warehouse}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>
            {getNumericValue(element.temsStock, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {getNumericValue(element.jdeStock, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {getNumericValue(element.binPending, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {getNumericValue(element.orders, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            {getNumericValue(element.difference, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            $ {getNumericValue(element.temsCost, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            $ {getNumericValue(element.totalTemsCost, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            $ {getNumericValue(element.jdeCost, 2)}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            $ {getNumericValue(element.totalJdeCost, 2)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTableHeader() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center'>Bodega </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Artículo</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Existencia Tems
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Existencia JDE</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Pendiente Binning
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Cantidad en OT</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Diferencias</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Costo Unitario Tems
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Costo Total Tems
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Costo Unitario JDE
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>
            Costo Total JDE
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  renderLoaderOrStock() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' content='Ejecutando' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderReport();
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  onPageSizeClick(event, data) {
    this.props.changeMonthReportPageSize(data.value);
  }

  onPageClick(value) {
    this.props.changeMonthReportPage(value);
  }

  render() {
    return (
      <Table striped className='toyota-grid'>
        {this.renderTableHeader()}
        <Table.Body>{this.renderLoaderOrStock()}</Table.Body>
        {this.renderPagination()}
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.monthClose.loading,
    'setReportList': state.monthClose.filteredList,
    'totalItems': state.monthClose.list.length,
    'pageNumber': state.monthClose.pageNumber,
    'pageSize': state.monthClose.pageSize,
  };
};

const {changeMonthReportPage, changeMonthReportPageSize} = Actions;

export default connect(mapStateToProps, {
  changeMonthReportPage,
  changeMonthReportPageSize,
})(TableRecords);
